export default __webpack_public_path__ + "static/media/mon_24.9ffb5e7e.png";